import React, { useState } from "react";
import emailjs from "@emailjs/browser";
import "../../../styles/home_page/homePageForm.css";

const HomePageForm = () => {
    const [email, setEmail] = useState("");
    const [phone, setPhone] = useState("");
    const [bodyMessage, setBodyMessage] = useState("");
    const [feedbackMessage, setFeedbackMessage] = useState("");

    const defaultEmail = "villalobos@comfortcare247.com"; // Your email
    const subject = "Comfort Care Interest From Website";

    const sendEmail = () => {
        if (!bodyMessage) {
            setFeedbackMessage("Please enter a message");
            return;
        }

        if (!email) {
            setFeedbackMessage("Please enter an email");
            return;
        }

        if (!phone) {
            setFeedbackMessage("Please enter a phone number");
            return;
        }

        const message = {
            to_email: defaultEmail,
            subject: subject,
            message: `Email: ${email}\nPhone Number: ${phone}\nMessage: ${bodyMessage}`,
        };

        
        emailjs.send("service_vkpsten", "template_llmp8ja", message, "mN0zxaFqya4cefzQZ")
            .then(() => {
                console.log("Email sent successfully");
                setFeedbackMessage("Your message has been sent successfully!");
                setEmail("");
                setPhone("");
                setBodyMessage("");
            })
            .catch((error) => {
                setFeedbackMessage("Error sending message. Please try again later.");
                console.error("Error", error);
            });
    };

    return (
        <div className="home-pg-form-container" id="home-page-contact-id">
            <div className="home-pg-form-title">Get in Touch</div>
            <div className="home-pg-form-subtitle">Urgent? Call now.</div>
            <button className="home-pg-form-phone-button">(951) 500 - 0904</button>
            <form className="home-pg-form">
                <input
                    className="home-pg-form-contact-email"
                    type="email"
                    placeholder="johndoe@email.com"
                    onChange={(e) => setEmail(e.target.value)}
                    required
                />
                <input
                    className="home-pg-form-contact-num"
                    type="tel"
                    placeholder="(999) 000-000"
                    onChange={(e) => setPhone(e.target.value)}
                    required
                />
                <textarea
                    className="home-pg-form-message"
                    name="message"
                    placeholder="Message"
                    onChange={(e) => setBodyMessage(e.target.value)}
                />
                <button
                    onClick={sendEmail}
                    className="home-pg-form-btn"
                    type="button"
                >
                    Send Message
                </button>
                {feedbackMessage && (
                    <div className="home-pg-form-feedback-message">
                        {feedbackMessage}
                    </div>
                )}
            </form>
        </div>
    );
};

export default HomePageForm;